<template>
<div class="chapter">
<div class="inner_page">
<p class="fm"><span>For those who lost loved ones in the attacks of September 11th</span></p>
<p class="fm1"><span>We will never forget</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// franmatter01.vue?332391f6